// src/components/Toast/Toast.jsx
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./Toast.scss";

export default function Toast({ message, type = "success", onClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onClose?.(), 450);
    }, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast1 ${type} ${visible ? "enter" : ""}`}>
      <div className="toast-content1">
        <div className="check">
          {type === "success" ? "✓" : type === "error" ? "!" : "i"}
        </div>
        <div className="message">
          <div className="text-1">{message}</div>
        </div>
      </div>

      {onClose && (
        <button className="close" onClick={() => setVisible(false)}>
          ×
        </button>
      )}

      <div className="progress" />
    </div>
  );
}

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["success", "error", "info"]),
  onClose: PropTypes.func,
};
